// This utility function combines class names conditionally, merging them
// with Tailwind's utility classes.
// It uses `clsx` to handle conditional class names and `twMerge` to ensure
// that Tailwind's utility classes are merged correctly, avoiding conflicts.
import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
